import * as React from 'react';

var _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgAuthy = function SvgAuthy(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 121"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#EC1C24",
        d: "M120 59.999C120 93.139 93.138 120 59.998 120 26.861 120 0 93.139 0 59.999 0 26.862 26.861 0 59.998 0 93.138 0 120 26.862 120 59.999"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m54.855 47.292 14.387 14.382a5.325 5.325 0 0 0 7.53 0 5.32 5.32 0 0 0 0-7.528L62.383 39.76C52.09 29.463 35.452 29.297 24.94 39.236a5 5 0 0 0-.284.257c-.046.046-.083.095-.13.136q-.07.066-.139.13a4 4 0 0 0-.253.28c-9.944 10.518-9.773 27.156.522 37.452l14.387 14.383a5.325 5.325 0 0 0 7.529 0 5.32 5.32 0 0 0 .005-7.527L32.19 69.96c-6.28-6.278-6.323-16.467-.13-22.798 6.33-6.193 16.514-6.148 22.795.13m18.568-19.159a5.317 5.317 0 0 0 .006 7.528L87.81 50.048c6.276 6.278 6.317 16.465.125 22.798-6.333 6.187-16.513 6.147-22.792-.132L50.757 58.329a5.325 5.325 0 0 0-7.53 0 5.32 5.32 0 0 0 0 7.53l14.382 14.388c10.297 10.296 26.933 10.463 37.447.523.098-.086.19-.166.287-.257l.127-.136c.047-.045.093-.086.136-.136.093-.086.171-.18.254-.278 9.944-10.513 9.778-27.146-.517-37.448L80.956 28.133a5.32 5.32 0 0 0-7.533 0"
    })));
};

export { SvgAuthy as ReactComponent };
//# sourceMappingURL=Authy.svg.es.js.map
